import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../../services/mainApi.service";
import { useCallback, useMemo, useState } from "react";
import { ITicketAutomationReceivedRuleEstablishment } from "../../../../../../models/ticket-automation-received-rule-establishment";
import Establishments from "./EstablishmentForm/Establishments";

// Rota do seu back-end base
const TICKET_AUTOMATION_RECEIVED_RULE_ESTABLISHMENT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedRuleEstablishment/";

const ticketAutomationReceivedRuleEstablishmentService =
  new MainApi<ITicketAutomationReceivedRuleEstablishment>(
    TICKET_AUTOMATION_RECEIVED_RULE_ESTABLISHMENT_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRuleEstablishment.";

interface IEstablishmentsPageProps {
  automationCode?: string;
}

const EstablishmentsPage = ({ automationCode }: IEstablishmentsPageProps) => {
  const { t } = useTranslation();
  const { id: ticketAutomationReceivedRuleId } = useParams();
  const [establishmentForm, setEstablishmentForm] = useState(false);
  const [selectedId, setSelectedId] = useState<string>();

  // Configuração das colunas da tabela
  const columns: GridColDef<ITicketAutomationReceivedRuleEstablishment>[] = [
    {
      field: "originalEstablishmentName",
      headerName:
        t(translationPath + "original_establishment_name") ||
        "Nome Estabelecimento",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "establishmentName",
      headerName:
        t(translationPath + "establishment_name") || "Nome Estabelecimento",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
  ];

  const handleAdd = () => {
    setEstablishmentForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutomationReceivedRuleEstablishment>,
  ) => {
    if (!params.row) return;
    setEstablishmentForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setEstablishmentForm(false);
  }, []);

  // Envia o ID da regra pai como filtro para a tabela buscar apenas os vinculados a ela
  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, [ticketAutomationReceivedRuleId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {establishmentForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Establishments
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            automationCode={automationCode}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!establishmentForm && (
        <Box height={600}>
          <Table<ITicketAutomationReceivedRuleEstablishment>
            showDefaultMacroFilters={false}
            service={ticketAutomationReceivedRuleEstablishmentService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_establishment") || "Add Establishment"
            }
            confirmOptions={{
              title: t(translationPath + "confirm_title"),
              description: t(translationPath + "confirm_description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default EstablishmentsPage;
